/**
 * Auth Feature Routes - 간단한 구조
 */

import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: () => import('./views/LoginPage.vue'),
        meta: {
            title: 'auth.pageTitle.login',
            requiresAuth: false,
            layout: 'blank'
        },
    },
    {
        path: '/auth/forgot-password2',
        name: 'ForgotPassword2',
        component: () => import('./components/ForgotPassword.vue'),
        meta: {
            title: 'auth.pageTitle.forgotPassword',
            requiresAuth: false,
            layout: 'blank'
        },
    },
    {
        path: '/auth/reset-password',
        name: 'ResetPassword',
        component: () => import('./views/ResetPasswordPage.vue'),
        meta: {
            title: 'auth.pageTitle.resetPassword',
            requiresAuth: false,
            layout: 'blank'
        },
    },
];
